import { AxiosInstance } from 'axios';
import {
  Announcement,
  AnnouncementWriteRequest,
  Maintenance,
  MaintenanceWriteRequest,
} from '@/api/announcements/announcements.types.ts';

export const createAnnouncementsApi = (api: AxiosInstance) => ({
  getAnnouncements: () => api.get<Announcement[]>('/v1/announcements'),

  getAnnouncement: (id: string) =>
    api.get<Announcement>(`/v1/announcements/${id}`),

  createAnnouncement: (body: AnnouncementWriteRequest) =>
    api.post<Announcement>('/v1/announcements', body),

  updateAnnouncement: (id: string, body: AnnouncementWriteRequest) =>
    api.patch<Announcement>(`/v1/announcements/${id}`, body),

  deleteAnnouncement: (id: string) =>
    api.delete<void>(`/v1/announcements/${id}`),

  getMaintenance: () => api.get<Maintenance>('/v1/maintenance'),

  updateMaintenance: (body: MaintenanceWriteRequest) =>
    api.put<Maintenance>('/v1/maintenance', body),
});
